'use strict';

class RemoteDataEvent {
	static get CREATE() { return 'create' };
	static get READ() { return 'read' };
	static get UPDATE() { return 'update' };
	static get DELETE() { return 'delete' };
	static get ERROR() { return 'error' };

	constructor(){
	}
}